<template>
  <template
    v-if="
      !(tokenBalance.isFetching.value && tokenBalance.isFirstFetching.value)
    "
  >
    <RegisterToken
      v-if="view === 'register'"
      :token="swap.toCurrency.token"
      @close="onClose"
      @success="onRegisterSuccess"
      @reject="onRegisterRejected"
    />
    <SwapConfirm
      v-if="view === 'swap'"
      @close="onClose"
      @success="onSwapSuccess"
      @reject="onSwapRejected"
    />
  </template>
</template>

<script setup lang="ts">
import { computed, inject, onBeforeMount, ref, watchEffect } from 'vue';
import { RegisterToken, SwapConfirm } from '@/components/Dialogs/Steps';
import { useDialogStore, useSwapStore, useTokensStore } from '@/store';
import { useCurrentAccountBalance } from '@/composables/useAccountBalance';
import { useI18n } from '@/composables/useI18n';

const dialogRef = inject('dialogRef');

type IProps = {
  visible?: boolean;
};

defineProps<IProps>();
defineEmits(['update:visible']);
const view = ref<'register' | 'swap'>('register');

const { t } = useI18n();

onBeforeMount(setDialogTitle);

const swap = useSwapStore();
const dialogStore = useDialogStore();
const tokensStore = useTokensStore();
const tokenBalance = useCurrentAccountBalance(
  computed(() => swap.toCurrency.token),
  { useSuffix: false },
);

function onClose() {
  dialogRef.value.close();
}

function onRegisterSuccess() {
  view.value = 'swap';
}

function onRegisterRejected() {
  view.value = 'register';
}

function onSwapSuccess() {
  onClose();
  view.value = 'register';
}

function onSwapRejected() {
  onClose();
  view.value = 'register';
}

function setDialogTitle() {
  const token = tokensStore.getToken(swap.toCurrency.token);
  if (view.value === 'register' && token) {
    dialogStore.setDialogTitle(t('tokens.registerToken', [token.symbol]));
    return;
  }
  dialogStore.setDialogTitle('Swap Tokens');
}

watchEffect(async () => {
  view.value = swap.directCoinTransfers ? 'swap' : 'register';

  setDialogTitle();
});
</script>

<style lang="scss" scoped></style>
